import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable()
export class PreviousRouteService {

  private previousUrl: string = null;
  private currentUrl: string = null;

  /**
   * Constructor
   *
   * @param router
   */
  public constructor(private router: Router) {
    this.currentUrl = this.router.url;

    router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;
      }
    });
  }

  /**
   * Gets the previous URL.
   *
   * @return string
   */
  public getPreviousUrl(): string {
    return this.previousUrl;
  }
}
